import { Reveal, SectionHeading, Accent } from "@/components/Reveal";
import { IMAGES } from "@/lib/content";
import { useLang } from "@/lib/i18n";

export const Manifesto = () => {
  const { t, c } = useLang();
  return (
  <section id="about" data-testid="about-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-36">
    <SectionHeading kicker={t.about.kicker} title={<Accent parts={t.about.title} />} testid="about-heading" />

    <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
      <div className="lg:col-span-5">
        <Reveal className="lg:sticky lg:top-28">
          <div className="relative overflow-hidden border border-line">
            <img
              src={IMAGES.plovdiv}
              alt={t.about.alt}
              className="w-full aspect-[4/5] object-cover grayscale hover:grayscale-0 transition-[filter] duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent pointer-events-none" />
            <p className="absolute bottom-4 left-4 font-mono text-xs uppercase tracking-[0.3em] text-mist/80">
              {t.about.city}
            </p>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-7 flex flex-col">
        {c.MANIFESTO.map((ch, i) => (
          <Reveal key={ch.num} delay={i * 0.08}>
            <div data-testid={`manifesto-chapter-${ch.num}`} className="group border-t border-line py-10 md:py-12 flex gap-8 md:gap-12 items-baseline">
              <span className="font-mono text-sm text-gold shrink-0">{ch.num}</span>
              <div>
                <h3 className="font-serif text-3xl md:text-4xl text-mist mb-4 group-hover:text-gold-light transition-colors duration-300">
                  {ch.title}
                </h3>
                <p className="text-dim leading-relaxed max-w-xl">{ch.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
        <div className="border-t border-line" />
      </div>
    </div>
  </section>
  );
};
